import { render, staticRenderFns } from "./OleMissExperiment9PrelabQuestion1.vue?vue&type=template&id=06bf7cd6&"
import script from "./OleMissExperiment9PrelabQuestion1.vue?vue&type=script&lang=js&"
export * from "./OleMissExperiment9PrelabQuestion1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VList } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFileInput,VForm,VList,VRow})
